var exports = {
  "u": "section__QBaB-F",
};

module.exports = exports;
